import { List, GitBranch, BarChart3 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { ViewMode } from './MovementsArea'

interface ViewModeToggleProps {
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
}

const VIEW_TABS: { key: ViewMode; label: string; icon: typeof List }[] = [
  { key: 'list', label: 'List', icon: List },
  { key: 'dayflow', label: 'Day Flow', icon: GitBranch },
  { key: 'gantt', label: 'Timeline', icon: BarChart3 },
]

export function ViewModeToggle({ viewMode, onViewModeChange }: ViewModeToggleProps) {
  return (
    <div className="flex items-center gap-1">
      {VIEW_TABS.map(({ key, label, icon: Icon }) => (
        <Button
          key={key}
          variant={viewMode === key ? 'secondary' : 'ghost'}
          size="sm"
          className="h-7 text-xs gap-1.5"
          onClick={() => onViewModeChange(key)}
        >
          <Icon className="h-3.5 w-3.5" />
          {label}
        </Button>
      ))}
    </div>
  )
}
